import React, { useEffect, useState } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from 'plotly.js/lib/core';
import scatter from 'plotly.js/lib/scatter';
import { CircularProgress, Box } from '@mui/material';

Plotly.register([scatter]);
const Plot = createPlotlyComponent(Plotly);

const LatePaymentLineGraoh = ({ data, loading, error, onLoaded, setHoveredPeriod }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!data) return;

    const sortedData = [...data].sort((a, b) => a.paymentDatePeriodEpoch - b.paymentDatePeriodEpoch);

    const groupedData = sortedData.reduce((acc, { paymentDatePeriod, lateOnTime }) => {
      if (!acc[paymentDatePeriod]) {
        acc[paymentDatePeriod] = { Late: 0, OnTime: 0, Total: 0 };
      }
      if (lateOnTime?.toLowerCase() === 'late payment') {
        acc[paymentDatePeriod].Late++;
      } else if (lateOnTime?.toLowerCase() === 'on time') {
        acc[paymentDatePeriod].OnTime++;
      }
      acc[paymentDatePeriod].Total++;
      return acc;
    }, {});

    const x = Object.keys(groupedData);
    const yLate = x.map((period) => groupedData[period].Late);
    const yOnTime = x.map((period) => groupedData[period].OnTime);
    const yTotal = x.map((period) => groupedData[period].Total);

    const traceTotal = {
      x,
      y: yTotal,
      type: 'scatter',
      mode: 'lines',
      name: 'Total Payments',
      fill: 'tozeroy',
      line: { shape: 'spline', color: '#CFC6C6', smoothing: 0.8 },
      opacity: 0.8,
      hoverinfo: 'x+y+name',
    };

    const traceLate = {
      x,
      y: yLate,
      type: 'scatter',
      mode: 'lines+markers',
      name: 'Late Payments',
      marker: { color: '#0E2756' },
      line: { shape: 'spline', smoothing: 0.8 },
      hoverinfo: 'x+y+name',
    };

    const traceOnTime = {
      x,
      y: yOnTime,
      type: 'scatter',
      mode: 'lines+markers',
      name: 'On Time Payments',
      marker: { color: '#B0C3E5' },
      line: { shape: 'spline', smoothing: 0.8 },
      hoverinfo: 'x+y+name',
    };

    setChartData([traceTotal, traceLate, traceOnTime]);
    onLoaded?.();
  }, [data, onLoaded]);

  const layout = {
    title: { text: 'Late Payments vs On-Time Payments Over Payment Period', font: { size: 18 } },
    xaxis: { title: { text: 'Payment Date Period' }, type: 'category' },
    yaxis: { title: { text: 'Number of Payments' } },
    showlegend: true,
    autosize: true,
    margin: { r: 100 },
    legend: { orientation: 'v', x: 1.05, y: 1, xanchor: 'center' },
    hovermode: 'x unified',
  };

  const config = {
    responsive: true,
    displaylogo: false,
    modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d'],
    displayModeBar: 'hover',
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) return <p>Error: {error}</p>;
  if (!chartData) return <p>No data available.</p>;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Plot
        data={chartData}
        layout={layout}
        config={config}
        style={{ width: '100%', height: '600px' }}
        onHover={(event) => {
          const period = event?.points?.[0]?.x;
          setHoveredPeriod?.(period);
        }}
        onUnhover={() => {
          setHoveredPeriod?.(null);
        }}
      />
    </div>
  );
};

export default LatePaymentLineGraoh;
